import { useGlobalStore } from '@/stores/global'
import { storeToRefs } from 'pinia'
import API from '@/services'
import type { Evento } from '@/types'

export function useMissionData() {
    const globals = useGlobalStore()
    const { missionPlan } = storeToRefs(globals)

    // ========== FUNCIONES API ==========

    const getMissionPlanByMission = async (missionId: string): Promise<string | null> => {
        try {
            console.log('🔍 Buscando plan de misión para mission:', missionId)

            const filters = {
                mission: missionId,
                start_date: '',
                end_date: '',
                source_unit: '',
                dest_unit: '',
                received: ''
            }

            const { status, data } = await API.listMissionPlans(filters)

            if (
                status === 200 &&
                data.Entries &&
                Array.isArray(data.Entries.Entry) &&
                data.Entries.Entry.length > 0
            ) {
                const firstPlan = data.Entries.Entry[0]
                const planId = firstPlan.plan_id

                console.log('✅ Plan encontrado:', planId)
                console.log('📋 Detalles del plan:', firstPlan)

                return planId
            } else {
                console.warn('⚠️ No se encontraron planes para la misión:', missionId)
                return null
            }
        } catch (error) {
            console.error('❌ Error obteniendo planes de misión:', error)
            return null
        }
    }

    const getMissionPlanByMissionId = async (missionId: string) => {
        try {
            const planId = await getMissionPlanByMission(missionId)

            if (planId) {
                console.log('📥 Obteniendo detalles del plan:', planId)
                const { status, data } = await API.getMissionPlan(planId)

                if (status === 200) {
                    missionPlan.value = data
                    console.log('✅ Plan de misión cargado:', data)
                    return data
                } else {
                    console.error('❌ Error obteniendo detalles del plan')
                    missionPlan.value = null
                    return null
                }
            } else {
                console.warn('⚠️ No se encontró plan_id para la misión')
                missionPlan.value = null
                return null
            }
        } catch (error) {
            console.error('❌ Error en getMissionPlanByMissionId:', error)
            missionPlan.value = null
            return null
        }
    }

    const getMissionEvents = async (missionId: string): Promise<Evento[]> => {
        const filter: Record<string, string> = { mission: missionId }

        try {
            const { status, data } = await API.getEvents(filter)
            if (status === 200) {
                const evt = data.Entries
                const temp: Evento[] = []
                if (Array.isArray(evt) && evt.length > 0) {
                    evt.forEach((element: any) => {
                        temp.push(element.Entry)
                    })
                }
                return temp
            } else {
                return []
            }
        } catch (error) {
            return []
        }
    }

    // ========== FUNCIONES GENÉRICAS REUTILIZABLES ==========

    const processMissionPlan = async (getMissionByUnitId: (unitId: string) => string | null, unitId: string, enabled: boolean = true): Promise<boolean> => {
        if (enabled) {
            const missionId = getMissionByUnitId(unitId)

            if (missionId) {
                console.log(`🚀 Cargando plan para mission: ${missionId} (unidad: ${unitId})`)
                try {
                    await getMissionPlanByMissionId(missionId)
                    console.log(`✅ Plan actualizado para unidad: ${unitId}`)
                    return true
                } catch (error) {
                    console.error(`❌ Error actualizando plan para unidad ${unitId}:`, error)
                    return false
                }
            } else {
                console.error(`❌ No se pudo obtener mission para unidad: ${unitId}`)
                missionPlan.value = null
                return false
            }
        } else {
            return true
        }
    }

    const processEvents = async (getMissionByUnitId: (unitId: string) => string | null, unitId: string, enabled: boolean = true): Promise<Evento[]> => {
        if (enabled) {
            const missionId = getMissionByUnitId(unitId)

            if (missionId) {
                console.log(`📅 Cargando eventos para mission: ${missionId} (unidad: ${unitId})`)
                try {
                    const events = await getMissionEvents(missionId)
                    console.log(`✅ ${events.length} eventos cargados para unidad: ${unitId}`)
                    return events
                } catch (error) {
                    console.error(`❌ Error cargando eventos para unidad ${unitId}:`, error)
                    return []
                }
            } else {
                console.error(`❌ No se pudo obtener mission para eventos de unidad: ${unitId}`)
                return []
            }
        } else {
            return []
        }
    }

    return {
        getMissionPlanByMission,
        getMissionPlanByMissionId,
        getMissionEvents,
        processMissionPlan,
        processEvents
    }
}
